import axios from 'axios'
import { ResponseWrapper, ErrorWrapper } from './util'

export default class BaseAPI {

  request = axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT
  })

  // constructor () {
  //   this.request.interceptors.response.use(
  //       res => res,
  //       err => {
  //         if(!navigator.onLine) {
  //           window.location = '/offline'
  //         }
  //         return Promise.reject(err)
  //       }
  //   )
  // }

  get entity(){}

  responseWrapper(...rest){
    return new ResponseWrapper(...rest)
  }

  errorWrapper(...rest){
    return new ErrorWrapper(...rest)
  }

  getCancelToken() {
    return axios.CancelToken
  }

  setCourseId(id){
    this.course_id = id
  }

  getCourseId(){
    const url = window.location.pathname.split('/')
    return this.course_id ? this.course_id : url[url.indexOf('courses') + 1]
  }

  /* --------------------- CRUD API CALLS --------------------- */
  getAll(){
    return new Promise((resolve, reject) => {
      return this.request.get(`${this.entity.route}`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  getById(id){
    return new Promise((resolve, reject) => {
      return this.request.get(`${this.entity.route}/${id}`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  create(data, config = null){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}`, data, config)
        .then(response => resolve(this.responseWrapper(response, this.entity.name, 'add')))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  update(id, data){
    data instanceof FormData ? data.append('_method', 'put') : data._method = 'put'

    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${id}`, data)
        .then(response => resolve(this.responseWrapper(response, this.entity.name, 'update')))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  delete(id){
    return new Promise((resolve, reject) => {
      return this.request.delete(`${this.entity.route}/${id}`)
        .then(response => resolve(this.responseWrapper(response, this.entity.name, 'delete')))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}
